import { useQuery } from "@tanstack/react-query"
import Single from "../../components/single/Single.tsx"
import "./ressource.scss"
import React, { useState } from 'react'
import { useParams } from "react-router-dom"

const singleRessource = {
  _id: "680df95eb6dd8b9c645460e0",
  title: "Test",
  info: {
    testid: "123456"
  },
  activities: [
  ],
};

function Ressource() {
  const params = useParams();
  const [activities, setActivities] = useState([]);

  const { isLoading, data } = useQuery({
    queryKey: ["ressource"],
    queryFn: async () => {
      const response = await fetch("/api/ressources/" + params.id)
      const testdata = await response.json();
      //const responsestatus = await fetch("/api/ressources/" + testdata[0].itsi);
      //const status = await responsestatus.json();
      const test = {
        title: testdata[0].name,
        info: {
          itsi: testdata[0].itsi,
          organization: testdata[0].organization,
          typ: testdata[0].type
        },
        activities:
          [
            {
              time: "",
              text: ""
            },
          ]
      }
      //console.log(testdata);
      //console.log(test);
      return await test;
    }
  });


  return (
    <div className="ressource">
      {isLoading ? (
        "Lade..."
      ) : (
        <Single {...data} />
      )}
    </div>
  )
}

export default Ressource